export default function Switch({ children, className, onChange, checked, botaoDeslizar= true }) {
    return (
        <div className={`relative items-center flex ${className}`}>
            {botaoDeslizar && <label className="relative inline-flex cursor-pointer">
                <input id="switch" type="checkbox" className="peer sr-only" onChange={onChange} checked={checked} />
                <label htmlFor="switch" className="hidden"></label>
                <div className="left-[0.01px] top-[-0.01px] peer h-[1.101em] w-[2.433em] rounded-full bg-divider-dark 
                after:absolute after:left-[0.137em] after:top-[0.137em] after:h-[0.826em] after:w-[0.826em] after:rounded-full after:bg-neutras-white after:transition-all after:content-[''] 
                peer-checked:after:left-[0.628em] peer-checked:after:top-[0.137em] peer-checked:bg-primary-medium peer-checked:after:translate-x-full"></div>
            </label>}
            {children}
        </div>
    )
}